import { render } from "./Uspjeh.vue?vue&type=template&id=07fdba22&scoped=true"
import script from "./Uspjeh.vue?vue&type=script&lang=js"
export * from "./Uspjeh.vue?vue&type=script&lang=js"

import "./Uspjeh.vue?vue&type=style&index=0&id=07fdba22&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fdba22"]])

export default __exports__